<div *ngFor="let notif of notifications" [class]="getClasses(notif)" class="l-col l-jc-start l-ai-stretch">
  <div class="l-flex-10 l-row l-jc-start l-ai-center">
    <div class="l-flex-90 l-row l-jc-start l-ai-center l-gap">
      <mat-icon>{{ notif.type | notificationIcon }}</mat-icon>
      <h4>{{ notif.title }}</h4>
    </div>
    <mat-icon class="click" (click)="removeNotification(notif)">close</mat-icon>
  </div>
  <div class="l-flex-90">
    {{ notif.body }}
  </div>
</div>
